import { DateRangePickerInput } from '../../components/Input/DateRangePickerInput';

export interface ClinicianDashboardToolbarProps {
  dateRange: [Date, Date] | null;
  onDateRangeChange: (dateRange: [Date, Date] | null) => void;
}

export function ClinicianDashboardToolbar({ dateRange, onDateRangeChange }: ClinicianDashboardToolbarProps) {
  return (
    <div className="flex flex-col gap-4 md:flex-row md:gap-0">
      <DateRangePickerInput
        value={dateRange}
        onChange={onDateRangeChange}
        className="w-[350px]"
        testId="date-range-input"
      />
    </div>
  );
}
